import React from "react";

export interface WidgetFileProps {
  content: unknown;
}

export function WidgetFile({ content }: WidgetFileProps): React.JSX.Element {
  const file = (content ?? {}) as Record<string, string>;
  return (
    <div className="flex items-center gap-2 p-2 rounded-lg border border-gray-200 bg-white text-sm my-1">
      <span className="material-icons-outlined text-base text-[#6B7280]">description</span>
      <span className="text-[#3A3F51] flex-1 truncate">{file.name ?? "file"}</span>
      {file.url && (
        <a
          href={file.url}
          target="_blank"
          rel="noreferrer"
          className="text-xs text-[#4F46E5] hover:underline">
          Open
        </a>
      )}
    </div>
  );
}
